import { useState } from "react";
import { loginUser } from "../Components/Authservice.ts";
import { useNavigate, Link } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../Components/Firebase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await loginUser(email, password);
      const user = userCredential.user;

      const userDoc = await getDoc(doc(db, "users", user.uid));
      const role = userDoc.data()?.role;
      console.log("Logged in role:", role);

      if (role === "creator") {
        navigate("/dashboard");
      } else {
        navigate("/explore");
      }
    } catch (error) {
      console.error("Login error:", error.message);
      alert("Failed to login: " + error.message);
    }
  };

  return (
    <div className="login-page">
      <div className="star-field">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="star"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      <div className="login-container">
        <h1 className="login-title">Welcome back!</h1>
        <p className="login-subtitle">Login to continue your anime journey</p>
        <form onSubmit={onSubmit} className="login-form">
          <label>Email</label>
          <div className="input-group">
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <label>Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-password"
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          <button type="submit" className="login-button">
            Log In
          </button>
          

          <div className="login-links">
            <span>
              Don’t have an account? <a href="/signup">Sign up</a>
            </span>
          </div>
        </form>
        <p className="mt-3">
  <Link to="/forgot-password" className="text-light">Forgot your password?</Link>
</p>

      </div>
    </div>
  );
};

export default Login;
